/**
 * Translation keys for the details refusals the portal can explain in the user's own language. The
 * server's sentence is English only, so it is the fallback rather than the message.
 */
const DETAILS_ERROR_KEYS: Readonly<Record<string, string>> = {
  'invalid-shared-email': 'invalid-email-message',
  'invalid-phone-number': 'invalid-phone-number-message',
};

/**
 * What to show when saving a colleague's details failed: the translated sentence for a known
 * refusal, else the server's own, else the generic fallback.
 */
export const detailsErrorMessage = (
  outcome: { readonly error?: string; readonly code?: string },
  t: (key: string) => string,
): string => {
  const key = outcome.code == null ? undefined : DETAILS_ERROR_KEYS[outcome.code];

  if (key != null) {
    return t(key);
  }

  return outcome.error ?? t('edit-user-failed');
};

export default detailsErrorMessage;
